import React from "react";

function TopIDToScroll() {
  return (
    <div>
      <span id="top"></span>
    </div>
  );
}

export default TopIDToScroll;
